import { Link } from "react-router-dom";
import { updates, categories, animeList } from "@/mocks/anime";

const catColor: Record<string, string> = {
  fairy: "bg-accent-100 text-accent-700",
  elf: "bg-secondary-100 text-secondary-700",
  monster: "bg-primary-100 text-primary-700",
};

export default function Updates() {
  return (
    <section className="py-14 md:py-20 bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-1">
            <p className="text-sm text-secondary-400 font-medium inline-flex items-center gap-2">
              <i className="ri-feedback-line"></i>
              最新追更
            </p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-white">
              别错过这一话
            </h2>
            <p className="mt-4 text-secondary-300 leading-relaxed">
              实时汇总各奇幻番剧的最新更新动态，追更入口清晰。想看什么题材的更新，一屏掌握。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {categories.map((c) => (
                <Link
                  key={c.type}
                  to={`/category/${c.type}`}
                  className="px-3 py-1.5 rounded-full bg-secondary-800 text-secondary-200 text-xs hover:bg-secondary-700 transition-colors inline-flex items-center gap-1.5"
                >
                  <i className={c.icon}></i>
                  {c.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2 bg-secondary-800/60 rounded-2xl overflow-hidden border border-secondary-700">
            <ul className="divide-y divide-secondary-700">
              {updates.map((u) => {
                const anime = animeList.find((a) => a.title === u.title);
                return (
                  <li key={`${u.title}-${u.ep}`}>
                    <Link
                      to={anime ? `/anime/${anime.id}` : "/"}
                      className="flex items-center gap-4 px-5 py-4 hover:bg-secondary-800/60 transition-colors"
                    >
                      <span
                        className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs ${catColor[u.category]}`}
                      >
                        <i className="ri-play-mini-fill"></i>
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-secondary-100 font-medium truncate">{u.title}</p>
                        <p className="text-xs text-secondary-400 mt-0.5 truncate">{u.ep}</p>
                      </div>
                      <span className="shrink-0 text-xs text-secondary-400 flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {u.time}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}